import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _archiveMenuRequest = {};
var _archiveMenuResponse = {};
var _archiveSectionRequest = {};
var _archiveSectionResponse = {};
var _bulkArchiveMenusRequest = {};
var _bulkArchiveMenusResponse = {};
var _bulkCreateDishesRequest = {};
var _bulkCreateDishesResponse = {};
var _bulkCreateMenusRequest = {};
var _bulkCreateMenusResponse = {};
var _bulkCreateSectionsRequest = {};
var _bulkCreateSectionsResponse = {};
var _bulkCreateVariationsRequest = {};
var _bulkCreateVariationsResponse = {};
var _bulkUnarchiveMenusRequest = {};
var _bulkUnarchiveMenusResponse = {};
var _bulkUpdateItemsRequest = {};
var _bulkUpdateItemsResponse = {};
var _bulkUpdateMenusRequest = {};
var _bulkUpdateMenusResponse = {};
var _bulkUpdateSectionsRequest = {};
var _bulkUpdateSectionsResponse = {};
var _catalog = { draftPublishedDate: 'google.protobuf.Timestamp' };
var _createDishRequest = {};
var _createDishResponse = {};
var _createDraftCatalogRequest = {};
var _createDraftCatalogResponse = { catalog: '_catalog' };
var _createMenuRequest = {};
var _createMenuResponse = {};
var _createSectionRequest = {};
var _createSectionResponse = {};
var _createVariationRequest = {};
var _createVariationResponse = {};
var _discardDraftCatalogRequest = {};
var _discardDraftCatalogResponse = {};
var _getItemRequest = {};
var _getItemResponse = {};
var _getMenuRequest = {};
var _getMenuResponse = {};
var _getSectionRequest = {};
var _getSectionResponse = {};
var _listCatalogsRequest = {};
var _listCatalogsResponse = { catalogs: '_catalog' };
var _listItemsRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _listItemsResponse = {};
var _listMenusRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _listMenusResponse = {};
var _listSectionsRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _listSectionsResponse = {};
var _publishDraftCatalogRequest = {};
var _publishDraftCatalogResponse = { catalog: '_catalog' };
var _removeDishFromSectionRequest = {};
var _removeDishFromSectionResponse = {};
var _unarchiveMenuRequest = {};
var _unarchiveMenuResponse = {};
var _updateItemRequest = {};
var _updateItemResponse = {};
var _updateMenuRequest = {};
var _updateMenuResponse = {};
var _updateSectionRequest = {};
var _updateSectionResponse = {};
function resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalog',
                destPath: '/v3/catalog',
            },
            {
                srcPath: '/restaurants/v3/draft-catalogs',
                destPath: '/v3/draft-catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalogs_test',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/_api/restaurants/v3/catalogs_test',
                destPath: '/v3/catalogs',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalog',
                destPath: '/v3/catalog',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalog',
                destPath: '/v3/catalog',
            },
            {
                srcPath: '/restaurants/v3/draft-catalogs',
                destPath: '/v3/draft-catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalogs_test',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/_api/restaurants/v3/catalogs_test',
                destPath: '/v3/catalogs',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalog',
                destPath: '/v3/catalog',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a draft version of the specified catalog.
 * Then you can update and publish the draft catalog by using the endpoints in the [Draft Catalogs category](https://dev.wix.com/api/rest/wix-restaurants/catalogs/draft-catalogs).
 *
 * > **Note:** You can't create more than one draft catalog per location.
 */
export function createDraftCatalog(payload) {
    var _a = serializer(_createDraftCatalogRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDraftCatalogResponse, {
        _catalog: _catalog,
    }).fromJSON;
    function __createDraftCatalog(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.CreateDraftCatalog',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDraftCatalog.fromReq = fromReq;
    __createDraftCatalog.__isAmbassador = true;
    return __createDraftCatalog;
}
/** Publishes a draft catalog to the live site by replacing the existing catalog. */
export function publishDraftCatalog(payload) {
    var _a = serializer(_publishDraftCatalogRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishDraftCatalogResponse, {
        _catalog: _catalog,
    }).fromJSON;
    function __publishDraftCatalog(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.PublishDraftCatalog',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishDraftCatalog.fromReq = fromReq;
    __publishDraftCatalog.__isAmbassador = true;
    return __publishDraftCatalog;
}
/** Discards a draft catalog. If you want to continue using [Bulk endpoints](https://dev.wix.com/api/rest/wix-restaurants/catalogs/draft-catalogs) for this catalog, you must first call the [Create Draft Catalog](https://dev.wix.com/api/rest/wix-restaurants/catalogs/draft-catalogs/create-draft-catalog) endpoint again. */
export function discardDraftCatalog(payload) {
    var _a = serializer(_discardDraftCatalogRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_discardDraftCatalogResponse, {}).fromJSON;
    function __discardDraftCatalog(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.DiscardDraftCatalog',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/discard',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __discardDraftCatalog.fromReq = fromReq;
    __discardDraftCatalog.__isAmbassador = true;
    return __discardDraftCatalog;
}
/** Adds multiple variations to a draft catalog. */
export function bulkCreateVariations(payload) {
    var _a = serializer(_bulkCreateVariationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateVariationsResponse, {}).fromJSON;
    function __bulkCreateVariations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateVariations',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/variations/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateVariations.fromReq = fromReq;
    __bulkCreateVariations.__isAmbassador = true;
    return __bulkCreateVariations;
}
/**
 * Updates multiple items in a draft catalog.
 * You can't update archived items.
 */
export function bulkUpdateItems(payload) {
    var _a = serializer(_bulkUpdateItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateItemsResponse, {}).fromJSON;
    function __bulkUpdateItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUpdateItems',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/items/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateItems.fromReq = fromReq;
    __bulkUpdateItems.__isAmbassador = true;
    return __bulkUpdateItems;
}
/** Adds multiple dishes to a draft catalog. */
export function bulkCreateDishes(payload) {
    var _a = serializer(_bulkCreateDishesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateDishesResponse, {}).fromJSON;
    function __bulkCreateDishes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateDishes',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/dishes/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateDishes.fromReq = fromReq;
    __bulkCreateDishes.__isAmbassador = true;
    return __bulkCreateDishes;
}
/** Adds multiple menus to a draft catalog. */
export function bulkCreateMenus(payload) {
    var _a = serializer(_bulkCreateMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateMenusResponse, {}).fromJSON;
    function __bulkCreateMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateMenus',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateMenus.fromReq = fromReq;
    __bulkCreateMenus.__isAmbassador = true;
    return __bulkCreateMenus;
}
/**
 * Updates multiple menus in a draft catalog.
 * You can't update archived menus.
 */
export function bulkUpdateMenus(payload) {
    var _a = serializer(_bulkUpdateMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateMenusResponse, {}).fromJSON;
    function __bulkUpdateMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUpdateMenus',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateMenus.fromReq = fromReq;
    __bulkUpdateMenus.__isAmbassador = true;
    return __bulkUpdateMenus;
}
/** Adds multiple sections to a draft catalog. */
export function bulkCreateSections(payload) {
    var _a = serializer(_bulkCreateSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSectionsResponse, {}).fromJSON;
    function __bulkCreateSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateSections',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/sections/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateSections.fromReq = fromReq;
    __bulkCreateSections.__isAmbassador = true;
    return __bulkCreateSections;
}
/**
 * Updates multiple sections in a draft catalog.
 * You can't update archived sections.
 */
export function bulkUpdateSections(payload) {
    var _a = serializer(_bulkUpdateSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateSectionsResponse, {}).fromJSON;
    function __bulkUpdateSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUpdateSections',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/sections/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateSections.fromReq = fromReq;
    __bulkUpdateSections.__isAmbassador = true;
    return __bulkUpdateSections;
}
/** Changes the `archived` boolean to `true` for multiple menus in a draft catalog. */
export function bulkArchiveMenus(payload) {
    var _a = serializer(_bulkArchiveMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveMenusResponse, {}).fromJSON;
    function __bulkArchiveMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkArchiveMenus',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveMenus.fromReq = fromReq;
    __bulkArchiveMenus.__isAmbassador = true;
    return __bulkArchiveMenus;
}
/** Changes the `archived` boolean to `false` for multiple menus in a draft catalog. */
export function bulkUnarchiveMenus(payload) {
    var _a = serializer(_bulkUnarchiveMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnarchiveMenusResponse, {}).fromJSON;
    function __bulkUnarchiveMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUnarchiveMenus',
            url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
                protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnarchiveMenus.fromReq = fromReq;
    __bulkUnarchiveMenus.__isAmbassador = true;
    return __bulkUnarchiveMenus;
}
/**
 * Retrieves catalogs, given the provided filtering, sorting and paging.
 * Note that there is a single catalog per location.
 */
export function listCatalogs(payload) {
    var _a = serializer(_listCatalogsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCatalogsResponse, { _catalog: _catalog }).fromJSON;
    function __listCatalogs(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListCatalogs',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCatalogs.fromReq = fromReq;
    __listCatalogs.__isAmbassador = true;
    return __listCatalogs;
}
/** Retrieves a menu. */
export function getMenu(payload) {
    var _a = serializer(_getMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMenuResponse, {}).fromJSON;
    function __getMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.GetMenu',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMenu.fromReq = fromReq;
    __getMenu.__isAmbassador = true;
    return __getMenu;
}
/** Retrieves a section. */
export function getSection(payload) {
    var _a = serializer(_getSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSectionResponse, {}).fromJSON;
    function __getSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.GetSection',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSection.fromReq = fromReq;
    __getSection.__isAmbassador = true;
    return __getSection;
}
/**
 * Updates a menu.
 * You can't update archived menus.
 */
export function updateMenu(payload) {
    var _a = serializer(_updateMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMenuResponse, {}).fromJSON;
    function __updateMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UpdateMenu',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menu.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMenu.fromReq = fromReq;
    __updateMenu.__isAmbassador = true;
    return __updateMenu;
}
/**
 * Updates a section.
 * You can't update archived sections. Note that every section belongs to a single menu, you can't add it to another menu.
 */
export function updateSection(payload) {
    var _a = serializer(_updateSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSectionResponse, {}).fromJSON;
    function __updateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UpdateSection',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{section.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSection.fromReq = fromReq;
    __updateSection.__isAmbassador = true;
    return __updateSection;
}
/** Retrieves menus, given the provided filtering, sorting and paging. */
export function listMenus(payload) {
    var _a = serializer(_listMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMenusResponse, {}).fromJSON;
    function __listMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListMenus',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMenus.fromReq = fromReq;
    __listMenus.__isAmbassador = true;
    return __listMenus;
}
/** Retrieves sections, given the provided filtering, sorting and paging. */
export function listSections(payload) {
    var _a = serializer(_listSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSectionsResponse, {}).fromJSON;
    function __listSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListSections',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/sections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSections.fromReq = fromReq;
    __listSections.__isAmbassador = true;
    return __listSections;
}
/** Creates a menu. */
export function createMenu(payload) {
    var _a = serializer(_createMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMenuResponse, {}).fromJSON;
    function __createMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateMenu',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMenu.fromReq = fromReq;
    __createMenu.__isAmbassador = true;
    return __createMenu;
}
/** Archives a menu. You can't update archived menus. */
export function archiveMenu(payload) {
    var _a = serializer(_archiveMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_archiveMenuResponse, {}).fromJSON;
    function __archiveMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ArchiveMenu',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archiveMenu.fromReq = fromReq;
    __archiveMenu.__isAmbassador = true;
    return __archiveMenu;
}
/** Unarchives a menu. */
export function unarchiveMenu(payload) {
    var _a = serializer(_unarchiveMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unarchiveMenuResponse, {}).fromJSON;
    function __unarchiveMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UnarchiveMenu',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unarchiveMenu.fromReq = fromReq;
    __unarchiveMenu.__isAmbassador = true;
    return __unarchiveMenu;
}
/** Archives a section. You can't update archived sections. */
export function archiveSection(payload) {
    var _a = serializer(_archiveSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_archiveSectionResponse, {}).fromJSON;
    function __archiveSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ArchiveSection',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archiveSection.fromReq = fromReq;
    __archiveSection.__isAmbassador = true;
    return __archiveSection;
}
/** Remove an item from a section */
export function removeDishFromSection(payload) {
    var _a = serializer(_removeDishFromSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeDishFromSectionResponse, {}).fromJSON;
    function __removeDishFromSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.RemoveDishFromSection',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}/remove-dish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeDishFromSection.fromReq = fromReq;
    __removeDishFromSection.__isAmbassador = true;
    return __removeDishFromSection;
}
/**
 * Creates a section.
 * You can't add the section to multiple menus, since every section belongs to a single menu.
 */
export function createSection(payload) {
    var _a = serializer(_createSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSectionResponse, {}).fromJSON;
    function __createSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateSection',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSection.fromReq = fromReq;
    __createSection.__isAmbassador = true;
    return __createSection;
}
/** Retrieves an item. */
export function getItem(payload) {
    var _a = serializer(_getItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getItemResponse, {}).fromJSON;
    function __getItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.GetItem',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getItem.fromReq = fromReq;
    __getItem.__isAmbassador = true;
    return __getItem;
}
/** Retrieves items, given the provided filtering, sorting and paging. */
export function listItems(payload) {
    var _a = serializer(_listItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listItemsResponse, {}).fromJSON;
    function __listItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListItems',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listItems.fromReq = fromReq;
    __listItems.__isAmbassador = true;
    return __listItems;
}
/**
 * Updates an item.
 * You can't update archived items.
 */
export function updateItem(payload) {
    var _a = serializer(_updateItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateItemResponse, {}).fromJSON;
    function __updateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UpdateItem',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/items/{item.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateItem.fromReq = fromReq;
    __updateItem.__isAmbassador = true;
    return __updateItem;
}
/** Creates a dish. */
export function createDish(payload) {
    var _a = serializer(_createDishRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDishResponse, {}).fromJSON;
    function __createDish(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateDish',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}/items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDish.fromReq = fromReq;
    __createDish.__isAmbassador = true;
    return __createDish;
}
/** Creates a variation. */
export function createVariation(payload) {
    var _a = serializer(_createVariationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createVariationResponse, {}).fromJSON;
    function __createVariation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateVariation',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/variations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createVariation.fromReq = fromReq;
    __createVariation.__isAmbassador = true;
    return __createVariation;
}
/** Adds multiple variations to a catalog. */
export function catalogsBulkCreateVariations(payload) {
    var _a = serializer(_bulkCreateVariationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateVariationsResponse, {}).fromJSON;
    function __catalogsBulkCreateVariations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.BulkCreateVariations',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/bulk/variations/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __catalogsBulkCreateVariations.fromReq = fromReq;
    __catalogsBulkCreateVariations.__isAmbassador = true;
    return __catalogsBulkCreateVariations;
}
/** Changes the `archived` boolean to `true` for multiple menus. */
export function catalogsBulkArchiveMenus(payload) {
    var _a = serializer(_bulkArchiveMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveMenusResponse, {}).fromJSON;
    function __catalogsBulkArchiveMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.BulkArchiveMenus',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/bulk/menus/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __catalogsBulkArchiveMenus.fromReq = fromReq;
    __catalogsBulkArchiveMenus.__isAmbassador = true;
    return __catalogsBulkArchiveMenus;
}
/** Adds multiple dishes to a catalog. */
export function catalogsBulkCreateDishes(payload) {
    var _a = serializer(_bulkCreateDishesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateDishesResponse, {}).fromJSON;
    function __catalogsBulkCreateDishes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.BulkCreateDishes',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/bulk/dishes/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __catalogsBulkCreateDishes.fromReq = fromReq;
    __catalogsBulkCreateDishes.__isAmbassador = true;
    return __catalogsBulkCreateDishes;
}
/** Adds multiple sections to a catalog. */
export function catalogsBulkCreateSections(payload) {
    var _a = serializer(_bulkCreateSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSectionsResponse, {}).fromJSON;
    function __catalogsBulkCreateSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.BulkCreateSections',
            url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/bulk/sections/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __catalogsBulkCreateSections.fromReq = fromReq;
    __catalogsBulkCreateSections.__isAmbassador = true;
    return __catalogsBulkCreateSections;
}
//# sourceMappingURL=http.impl.js.map